import { ElementRef } from '@angular/core';
import { Selectors } from 'src/app/data/enum/selectors';
import gsap from 'gsap';

export default (
  pageRef: ElementRef,
  isAbstract: boolean,
  isBrowseTitlesPage?: boolean,
): GSAPTimeline => {
  const coreTimeline = gsap.timeline({ paused: true });
  const parentElement = pageRef.nativeElement;
  const parentChildrenSelector = gsap.utils.selector(parentElement);
  const blackOverlay = parentChildrenSelector('[data-animation="tv-frame-screen"]');
  const disclaimer = parentChildrenSelector(Selectors.DISCLAIMER);

  // Opening Screen component animation
  function openingScreenTimeline(): GSAPTimeline {
    const timeline = gsap.timeline({
      yoyo: true,
      repeat: 1,
      repeatDelay: 4,
      ease: 'none',
    });
    const introCopyElement = parentChildrenSelector(Selectors.OPENING_SCREEN_COPY);
    const introModal = parentChildrenSelector(Selectors.OPENING_SCREEN_MODAL);
    timeline
      .fromTo(introModal, { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.85 }, 0.5)
      .fromTo(
        introCopyElement,
        { autoAlpha: 0, y: 30, duration: 0.35 },
        { autoAlpha: 1, y: 0, duration: 0.35 },
        '-=0.4',
      );
    return timeline;
  }

  // Miscelaneous Elements animation
  function miscElementsAnimation(): GSAPTimeline {
    const timeline = gsap.timeline({ ease: 'none', defaults: { duration: 0.5 } });
    const navigationButton = Selectors.NAVIGATION_BUTTON;
    const questionMarkButton = parentChildrenSelector(Selectors.QUESTION_MARK_BUTTON);

    timeline
      .fromTo(navigationButton, { x: -200, autoAlpha: 0 }, { x: 0, autoAlpha: 1 }, 0)
      .fromTo(questionMarkButton, { x: -200, autoAlpha: 0 }, { x: 0, autoAlpha: 1 }, 0);
    return timeline;
  }

  coreTimeline.add(openingScreenTimeline()).addLabel('scene2', '-=1');
  if (blackOverlay.length > 0) coreTimeline.add(gsap.to(blackOverlay, { autoAlpha: 0 }), 'scene2');
  !isBrowseTitlesPage && coreTimeline.add(remoteControlTimeline(isAbstract), 'scene2');
  coreTimeline
    .add(miscElementsAnimation(), 'scene2')
    .fromTo(disclaimer, { autoAlpha: 0 }, { autoAlpha: 1 }, '+=0');

  return coreTimeline;
};

// Remote control component animation
export function remoteControlTimeline(isAbstract: boolean): GSAPTimeline {
  const buttonElement = `[data-animation="control-button-highlights${
    isAbstract ? '-abstract' : ''
  }"]`;
  const tween: GSAPTween = gsap.to(
    buttonElement,
    isAbstract
      ? {
          '--drop-shadow-color': 'rgba(82, 146, 231, 1)',
          '--drop-shadow-blur': '7px',
          duration: 1,
          stagger: { each: 0.5, repeat: -1, yoyo: true, repeatDelay: 1 },
        }
      : {
          opacity: 0,
          repeat: -1,
          duration: 1,
          yoyo: true,
          repeatDelay: 0.5,
        },
  );

  const timeline = gsap.timeline({
    onComplete: () => {
      gsap.timeline({ id: 'control-buttons' }).add(tween);
    },
  });
  const remoteControl = Selectors.REMOTE_WRAPPER;
  const tooltipElement = Selectors.REMOTE_TOOLTIP;

  timeline
    .fromTo(remoteControl, { autoAlpha: 0 }, { autoAlpha: 1, duration: 0.1 }, 0)
    .fromTo(
      remoteControl,
      { y: 100, x: 500, rotate: 10 },
      { y: 0, x: 0, rotate: 0, ease: 'power4.out', duration: 1.5 },
      0.1,
    )
    .from(tooltipElement, { autoAlpha: 0, x: 30 });

  return timeline;
}
